import httpClient from "../lib/HttpClient"

export const createSubcategoryHttp = async (addInputDTO) => {
    return await httpClient.post("subcategory/add",addInputDTO)
}
export const updateSubcategoryHttp = async (updateInputDTO) => {
    return await httpClient.put("subcategory/update",updateInputDTO)
}
export const deleteSubcategoryHttp = async (id) => {
    return await httpClient.delete(`subcategory/delete?id=${id}`)
}
export const getSubcategoryHttp = async (id) => {
    return await httpClient.get(`subcategory/get?id=${id}`)
}
export const getSubcategoryByBranchIdHttp = async (id) => {
    return await httpClient.get(`subcategory/get-by-branch-id?branchId=${id}`)
}
export const getSubcategoriesHttp = async (paginationInputDTO) => {
    return await httpClient.post("subcategory/get",paginationInputDTO)
}